import Tag from "@jbhi-fi/lanyard-ui/components/Tag/Tag";

export const MarketplaceTag: React.FC = () => {
  return <Tag type="info" content="Marketplace" />;
};
